// Core packages
import { Injectable } from '@angular/core';

// Third party packages
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Custom packages
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class CreditsafeService {

  /**
   * Class constructor
   */
  constructor(
    private apiService: ApiService,
    private helperService: HelperService
  ) { }

  /**
   * Get an existing company by Vat number
   * 
   * @param vatNumber The company Vat number 
   * 
   * @returns object|null The company data found or null
   */
  public getCompanyByVatNumber(vatNumber: string): Observable<any> {
    return this.apiService.apiCall('GET', `utils/creditsafe-search-vatnumber?vatNumber=${vatNumber}`, {}, {}, true, true).pipe(
      catchError(err => {
        this.helperService.handleError(err);
        return throwError(err);
      })
    );
  }

  /**
   * Get an existing company by Name
   * 
   * @param companyName The company name 
   * 
   * @returns object|null The company data found or null
   */
  public getCompanyByCompanyName(companyName: string): Observable<any> {
    return this.apiService.apiCall('GET', `utils/creditsafe-search-name?name=${companyName}`, {}, {}, true, true).pipe(
      catchError(err => {
        this.helperService.handleError(err);
        return throwError(err);
      })
    );
  }
}
